import { useContext } from "react";
import { StoreLocatorContext } from "../../../../components/StoreLocator/context/StoreLocatorContext";
export const useStoreLocatorContext = () => {
    return useContext(StoreLocatorContext);
};
//# sourceMappingURL=useStoreLocatorContext.js.map